import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tgp-payment-callback',
  templateUrl: './payment-callback.component.html',
  styleUrls: ['./payment-callback.component.scss']
})
export class PaymentCallbackComponent {
  constructor() {
    if (document.readyState === 'complete') {
      // @ts-ignore
      parent.iframeLoaded(window.location.href);
    } else {
      window.onload = () => {
        // @ts-ignore
        parent.iframeLoaded(window.location.href);
      };
    }
  }

}
